const fetchWithToken = (url: RequestInfo | URL, options?: RequestInit): Promise<Response> => {
  return fetch(url, {
    ...options,
    credentials: 'include',
  });
};

const fetchUnauthed = (url: RequestInfo | URL, options?: RequestInit): Promise<Response> =>
  fetch(url, {
    ...options,
  });

export { fetchWithToken, fetchUnauthed };
